import { Button } from "antd";
import React from "react";

const AccountManagementActions = ({
   actionTitle,
   actionType,
   actionExplanation,
   actionExplanation2,
   actionExplanation3,
   actionButton,
   showModal,
   showModalType
}) => {
   return (
      <div>
         <div className="d-flex flex-column" style={{ gap: "4px" }}>
            <span className="subtitle-action">{actionTitle}</span>
            <span className="action-desc">
               {actionType}
               <strong> {actionExplanation} </strong>
               {showModalType === "delete" && (
                  <>
                     {actionExplanation2} <strong> {actionExplanation3}</strong>
                  </>
               )}
            </span>
         </div>

         <Button
            className="deactivate"
            color="primary"
            onClick={() => showModal(showModalType)}
            style={{ marginTop: "10px" }}
         >
            {actionButton}
         </Button>
      </div>
   );
};

export default AccountManagementActions;
